import { BoxFullWidth, ColumnBoxFlexFullWidth, ColumnFlexBox, FlexBox } from '../common/boxes';
import { ChangeEvent, useCallback, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { TEXTS } from '../../core/texts';
import { ButtonWithLoader } from '../common/ButtonWithLoader';
import { Search } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import DocumentsTable from './DocumentsTable';
import { useQueryParamsState } from '../../hooks/useQueryParamsState';
import DocumentRevisionModal from './DocumentRevisionModal';
import CustomerInfo from './CustomerInfo';
import { BaseObj } from '../../types/baseObj';
import { useGetCustomerDocuments } from '../../queryHooks/customer/useGetCustomerDocuments';

export interface IDocumentsState extends BaseObj {
  customerId: number | null;
  revisionId: string | null;
  download: string | null;
}

const initialState: IDocumentsState = { customerId: null, revisionId: null, download: null };

const Documents = () => {
  const theme = useTheme();
  const [state, setState] = useState<IDocumentsState>(initialState);
  const { queryParamState, isPrePopulated } = useQueryParamsState({ state, setState });
  const { data: documents, isFetching } = useGetCustomerDocuments({ customerId: state.customerId });
  const handleSearchBtn = useCallback((e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setState(prev => ({ ...initialState, customerId: e.target.customerId.valueAsNumber }));
  }, []);

  return (
    <ColumnBoxFlexFullWidth>
      <ColumnBoxFlexFullWidth borderBottom={1} pb={2} borderColor={theme.palette.primary.main}>
        <form onSubmit={handleSearchBtn}>
          <ColumnFlexBox>
            <FlexBox alignItems={'center'} alignContent={'center'}>
              {
                isPrePopulated &&
                <TextField name={'customerId'} label={TEXTS.CUSTOMER_ID} required type={'number'}
                           defaultValue={queryParamState.customerId}
                           InputProps={{ inputProps: { min: 0 } }}
                           sx={{ mr: { mobile: 1, laptop: 2 } }}
                />
              }
              <Box>
                <ButtonWithLoader loading={isFetching} type={'submit'} startIcon={<Search/>}>
                  {TEXTS.SEARCH}
                </ButtonWithLoader>
              </Box>
            </FlexBox>

            {
              !!state.customerId &&
              <Box mt={2}>
                <CustomerInfo customerId={state.customerId}/>
              </Box>
            }
          </ColumnFlexBox>
        </form>
      </ColumnBoxFlexFullWidth>
      {
        documents &&
        <BoxFullWidth mt={4}>
          {
            !!documents.length
              ? <DocumentsTable documents={documents} state={state} setState={setState}/>
              : <Typography>{TEXTS.NO_RECORDS_FOUND}</Typography>
          }
        </BoxFullWidth>
      }
      {
        state.revisionId &&
        <DocumentRevisionModal state={state} setState={setState}/>
      }
    </ColumnBoxFlexFullWidth>
  );
};

export default Documents;